<template>
  <ListaCXC />
</template>

<script>
import ListaCXC from '@/components/CXC/ListaCXC.vue'
export default {
  name: 'CXCView',
  components: { ListaCXC }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/CXCView.vue